export const getQueryParams = (queryParams, paramsCode) => {
    const urlParams = new URLSearchParams(queryParams);
    const myParam = urlParams.get(paramsCode);

    return myParam || "";
};

export const createCampaignCode = (queryParams = "") => {
    return getQueryParams(queryParams, "c");
};

export const createPartnerCode = (queryParams = "") => {
    return getQueryParams(queryParams, "p");
};

export const createSalesAgentCode = (queryParams = "") => {
    return getQueryParams(queryParams, "a");
};
